export { detectTestFiles } from './detect-spec-files';
